import { sharedMicrophoneStreamFactory } from "./microphoneStreamFactory";

/**
 * Ensures microphone permission + live stream exist before RTCPeerConnection.
 * Required so Chrome publishes real LAN IPs (not .local mDNS) that physical UCM can reach.
 */
export const primeMicrophoneAccess = async () => {
  await sharedMicrophoneStreamFactory({ audio: true, video: false });
  return true;
};
